<template>
  <b-container class="form-container bg-white shadow">
      <b-alert show variant="danger">Forbidden: {{reason}}</b-alert>
  </b-container>
</template>

<script>
export default {
  name: 'Forbidden',
  props: {
    reason: {
      type: String,
      default: 'You are not permitted to access this content',
    },
  },
};
</script>
